import { LipstickType } from "./v1";

export type LipstickTypeV1Type = keyof typeof LipstickType;
export type LipstickTypeType = LipstickTypeV1Type;
